import { useAuth0 } from '@auth0/auth0-react'
import { Button, Card } from '@helix-ds/react'

const HEADING = 'text-text-heading dark:text-white font-semibold tracking-tight'
const SUBTLE = 'text-sm font-medium text-text-body-subtle dark:text-gray-400'

/**
 * Friendly landing for an authenticated user who resolves NO usable access yet
 * — e.g. an invited clinician who signed in but has not accepted their case
 * invitation, or an identity not provisioned in any organization. Reached via
 * ``homePathForPermissions`` (NO_ACCESS_HOME) instead of dead-ending them on the
 * order workspace's "no permission" empty table.
 *
 * It intentionally exposes nothing org- or case-specific (the user has no
 * permissions); it only explains next steps and offers sign-out.
 */
export default function NoAccess() {
  const { logout } = useAuth0()

  const handleSignOut = () => {
    logout({ logoutParams: { returnTo: `${window.location.origin}/login` } })
  }

  return (
    <main className="flex min-h-screen w-full items-center justify-center bg-background-gray p-6 dark:bg-gray-950">
      <Card className="w-full max-w-md" aria-labelledby="no-access-heading">
        <h1 id="no-access-heading" className={`${HEADING} text-xl`}>
          You don&apos;t have access yet
        </h1>
        <div className="mt-4 flex flex-col gap-4" role="status">
          <p className="text-sm font-medium text-text-body dark:text-gray-300">
            Your account isn&apos;t set up with access to anything yet.
          </p>
          <p className={SUBTLE}>
            If you were invited to collaborate on a Case Connect case, open the link in your
            invitation email to accept it. If you believe this is a mistake, contact your
            administrator.
          </p>
          <Button type="button" variant="secondary" size="sm" onClick={handleSignOut}>
            Sign out
          </Button>
        </div>
      </Card>
    </main>
  )
}
